export const config = {
    appname: 'BHPetrol',
    client_id: '240220106526593', // App ID
    facebook_app_id: '240220106526593', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'stgbhp',
    agency_id: '',
    bzbsUrl: 'https://stgbhp.buzzebees.com.my',
    bzbsModuleUrl: 'https://bhpetrolstgmodule.buzzebees.com.my',
    bzbsAddItemFromList: 'https://stg.buzzebees.com.my/api/cart/',
    bzbsBlobUrl: 'https://stgbuzzebeesmy.blob.core.windows.net',
    bzbsShoppingCartApiUrl: 'https://shoppingcartstgmodule2.buzzebees.com.my', //api shopping cart
    bzbsShoppingCartUrl: 'https://stgshoppingcartservice2.buzzebees.com.my', //url redirect website
    bzbsAddItem: 'https://stgcart.buzzebees.com.my/payment/AddItem.aspx?id=',
    bzbsShoppingBasket: 'https://stgcart.buzzebees.com.my/paymentV2/cart.aspx',
    bzbsWebUrl: 'https://stw.buzzebees.com.my',
    bzbsPointExpire: 'https://stw.buzzebees.com.my/Views/Point/Expire.aspx?token=',
    miscUrl: 'https://stgmisc.buzzebees.com.my',
    bzbsGaId: 'GTM-TDZJZ749',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],
};
